import React from 'react'
import HomeScreen from '../component/HomePage/HomeScreen'
import OurStory from '../component/HomePage/OurStory'
import Award from '../component/HomePage/Award'
import WhyChooseUs from '../component/HomePage/WhyChooseUs'
import PracticeAreas from '../component/HomePage/PracticeArea'
import ContactUs from '../component/HomePage/ContactUs'
import Tagline from './Tagline'

export default function HomePage() {
  return (
    <div className=' w-full  ' >
        <HomeScreen/>
        
        <OurStory/>
        {/* <Award/> */}
        <Tagline/>
        <WhyChooseUs/>
        <PracticeAreas/>
        <ContactUs/>
    </div>
  )
}
